import { Route, Step } from "@/flow/domain/flow";

export function isStep(item: Route | Step): item is Step {
  return (item as Step).connectorSpecId !== undefined;
}
